<app-loader *ngIf="loader"></app-loader>

<div class="flex justify-content-between align-items-center mt-3">
    <div class="flex">
        <p-button label="Update" icon="pi pi-save" class="p-button-primary" size="small"
            (click)="confirmSaveGLDefaults()">
        </p-button>

        <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small"
            (onClick)="onCancel()">
        </p-button>
    </div>

</div><br>


<p-table #dt1 [value]="glDefaults" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,15,20]" [scrollable]="true"
    scrollHeight="600px" tableStyleClass="gl-fixed-table" styleClass="p-datatable-sm p-datatable-gridlines"
    responsiveLayout="scroll" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">


    <ng-template pTemplate="header">
        <tr>
            <th style="width: 15%; min-width: 150px;">Account Type</th>
            <th style="width: 25%; min-width: 220px;">Default Account Name</th>
            <th style="width: 20%; min-width: 200px;">Mapped GL Account Code</th>
            <th style="width: 30%; min-width: 260px;">GL Account Name</th>

        </tr>
    </ng-template>


    <ng-template pTemplate="body" let-row>
        <tr>
            <td>{{ row.accountType }}</td>
            <td>{{ row.accountName }}</td>
            <td>
                <p-dropdown [options]="row.filteredAccounts" optionLabel="accountCode" optionValue="accountsId"
                    appendTo="body" [(ngModel)]="row.glAccountId" placeholder="Select Account" styleClass="gl-dropdown"
                    [filter]="true" [showClear]="true" (onChange)="onGLAccountChange(row)"
                    (onClear)="onGLAccountClear(row)">

                    <ng-template pTemplate="item" let-item>
                        {{ item.accountCode }} - {{ item.accountName }}
                    </ng-template>

                    <ng-template pTemplate="selectedItem" let-item>
                        <span *ngIf="row.glAccountId">{{ item?.accountCode }}</span>
                    </ng-template>
                </p-dropdown>

            </td>


            <td>
                {{ row.glAccountName || '-' }}
            </td>
        </tr>
    </ng-template>

</p-table>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>